import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step1", "step2", "phone", "phoneLabel", "next"]

  connect() {
    this.showStep1()
  }

  next(event) {
    event.preventDefault()

    const phoneField = this.phoneTarget
    if (!phoneField.value.trim()) {
      alert("Введите номер телефона")
      phoneField.focus()
      return
    }

    this.step1Target.style.opacity = '0'
    this.step1Target.style.transform = 'translateX(-20px)'

    setTimeout(() => {
      // this.hideStep1()
      this.hideNextButton()
      this.showPhoneLabel()
      this.showStep2()
      this.step1Target.style.opacity = '1'
      this.step1Target.style.transform = 'translateX(0)'
    }, 200)
  }

  back() {
    this.step2Target.style.opacity = '0'
    this.step2Target.style.transform = 'translateX(20px)'

    setTimeout(() => {
      this.hideStep2()
      this.hidePhoneLabel()
      // this.showStep1()
      this.showNextButton()
      this.step2Target.style.opacity = '1'
      this.step2Target.style.transform = 'translateX(0)'
    }, 200)
  }

  showNextButton() {
    this.nextTarget.style.display = 'block'
  }

  showPhoneLabel() {
    this.phoneLabelTarget.style.display = 'block'
    this.phoneLabelTarget.parentNode.classList.add("mb-12")
  }

  showStep1() {
    this.step1Target.style.display = 'block'
  }

  showStep2() {
    this.step2Target.style.display = 'block'
  }

  hideNextButton() {
    this.nextTarget.style.display = 'none'
  }

  hidePhoneLabel() {
    this.phoneLabelTarget.style.display = 'none'
    this.phoneLabelTarget.parentNode.classList.remove("mb-12")
  }

  hideStep1() {
    this.step1Target.style.display = 'none'
  }

  hideStep2() {
    this.step2Target.style.display = 'none'
  }
}
